import React, { useContext, useMemo } from 'react';
import { styled } from '@mui/material';

import { PageContext } from 'pages/Survey/PageProvider';
import { Box, Stack, Text } from 'shell/components';

const QuestionTemplate = ({ review = false }) => {
    const { renderQuestions, questions, survey } = useContext(PageContext);

    const renderDefaultQuestionsMemo = useMemo(() => {
        return renderQuestions(true);
    }, [questions, survey]);

    const renderQuestionsMemo = useMemo(() => {
        return renderQuestions(false);
    }, [questions, survey]);

    return (
        <RootStack spacing={10}>
            {!review && (
                <Stack spacing={1}>
                    <Text align={'center'} variant={'h6'} weight={'semibold'}>
                        Welcome to Ensightful!
                    </Text>
                    <Text variant={'p1'}>
                        Before you start your course, please fill out this form to help your instructor know you better
                        and to help place you into a team.
                    </Text>
                </Stack>
            )}
            <Stack>
                <CustomBox>{renderDefaultQuestionsMemo}</CustomBox>
                <Stack spacing={6}>{renderQuestionsMemo}</Stack>
            </Stack>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        marginTop: theme.spacing(10),
        width: '100%',
    };
});

const CustomBox = styled(Box)(({ theme }) => {
    return {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto auto',
        gridGap: theme.spacing(6),
        marginBottom: theme.spacing(6),
    };
});

export default QuestionTemplate;
